var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{class:['bar', _vm.type || '']})])
}
var staticRenderFns = []

export { render, staticRenderFns }